import { surveyModeRedirection } from '/app/utils/route';
import { defineAppRouteMiddleware } from '/app/utils/app';

export default defineAppRouteMiddleware((to) => {
    if (to.name === 'challenges.survey') {
        return surveyModeRedirection(to);
    }
})
